import { Subscription } from 'rxjs';
import { Component, Output, Input, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { PageLayoutService } from '../services/page-layout.service';
import { PageTemplate } from '../models/page-layout.model';

@Component({
  selector: 'page-layout',
  template: `<div
  *ngFor="let pageTemplate of pageTemplateObjects"
  class='pl' (click)="selectTemplate(pageTemplate)"
  >
  <div class="pl-Row_Layout mat-elevation-z2" [ngClass]="{'cr-SelectedItem': selectedMongoId === pageTemplate.mongoId, 'selected': (selectedMongoId === pageTemplate.mongoId && selectable), 'cr-ItemRow': selectable}">
    <div class="pl-Row_Layout-col" [ngClass]="pageTemplate.cssClass"></div>
    <h2 class="margin-top-15 center" [ngClass]="{'text-link': selectable && pageTemplate.mongoId !== selectedMongoId}">{{pageTemplate.displayName}}</h2>
  </div>
</div>`
})
export class PageLayoutComponent implements AfterViewInit, OnDestroy {

  pageTemplateObjects: PageTemplate[] = [];
  @Output() onSelected: EventEmitter<PageTemplate> = new EventEmitter<PageTemplate>();
  @Input() selectedMongoId: string;
  @Input() selectable: boolean;
  layoutSubscription: Subscription;

  constructor(private pageLayoutService: PageLayoutService) {
    this.layoutSubscription = this.pageLayoutService.retrieveLayoutTemplates().subscribe(response => {
        if ( response ) {
            this.pageTemplateObjects = response;
            this.pageTemplateObjects.forEach(pageTemplate => {
              pageTemplate.cssClass = 'col-' + this.stringReplace(pageTemplate.displayName, /\//g, '-');
              pageTemplate.displayName = this.buildDisplayName(pageTemplate.displayName); // , pageTemplate.theme.displayName);
            });
        }
    });
  }
  ngAfterViewInit(): void {
    this.selectable = this.onSelected.observers.length > 0;
  }

  stringReplace(input: string, replaceFunction: RegExp, replacement: string): string {
    return input.replace(replaceFunction, replacement);
  }
  buildDisplayName(name: string): string {
    let columnCount = (name.match(/\//g) || []).length + 1;
    let columnName = columnCount > 1 ? 'Columns' : 'Column';
    // return `${name} (${columnCount} ${columnName}): ${associatedThemeName}`;
    return `${name} (${columnCount} ${columnName})`;
  }
  selectTemplate(layout): void {
    if (this.selectable) {
      if (this.selectedMongoId !== layout.mongoId) {
        this.selectedMongoId = layout.mongoId;
        this.onSelected.emit(layout);
      }
    }
  }
  ngOnDestroy(): void {
    this.layoutSubscription.unsubscribe();
  }
}
